import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import { observer } from 'mobx-react'
import mainStore from '@components/Main/store'
import store from './store'

@observer
export default class extends Component {
  componentDidMount() {
    store.getList()
  }

  render() {
    const {
      merchantInfo: {
        logo_path,
        name,
        grade: { grade_level }
      }
    } = mainStore

    let header = [<a href="#/localMerchant/home">我的店铺</a>, '商家等级']
    return (
      <HeaderView title="商家等级" header={header}>
        <div className={styles.box}>
          <div className={styles.top}>
            <div className={styles.bar}>
              <img className={styles.logo} src={logo_path} />
              <div className={styles.abstract}>
                <div>
                  <em>{name}</em>
                  {grade_level == 0 && (
                    <i className={`${styles.gradeIcon} ${styles.grade1}`} />
                  )}
                  {grade_level == 1 && (
                    <i className={`${styles.gradeIcon} ${styles.grade2}`} />
                  )}
                  {grade_level == 2 && (
                    <i className={`${styles.gradeIcon} ${styles.grade3}`} />
                  )}
                  {grade_level == 3 && (
                    <i className={`${styles.gradeIcon} ${styles.grade4}`} />
                  )}
                  {grade_level == 4 && (
                    <i className={`${styles.gradeIcon} ${styles.grade5}`} />
                  )}
                </div>
                <p>
                  {/*您在上一个考核周期战胜了同等级{rate}%的商家，请继续努力吧！*/}
                  提高商家等级会获得更多的免费推广资源哦，请继续努力吧。
                </p>
              </div>
              <a
                style={{ float: 'right', color: '#448afc' }}
                href="#/localMerchant/myShop/regular"
              >
                查看等级规则 》
              </a>
            </div>

            <div className={styles.bar}>
              <a href="#/localMerchant/myShop/regular">
                <ul className={styles.rank}>
                  <li>
                    <span>
                      <i className={`${styles.rankIcon} ${styles.rank1}`} />
                    </span>
                    <p>普通</p>
                  </li>
                  <li className={grade_level >= 1 ? styles.on : ''}>
                    <em />
                    <span>
                      <i className={`${styles.rankIcon} ${styles.rank2}`} />
                    </span>
                    <p>铜牌</p>
                  </li>
                  <li className={grade_level >= 2 ? styles.on : ''}>
                    <em />
                    <span>
                      <i className={`${styles.rankIcon} ${styles.rank3}`} />
                    </span>
                    <p>银牌</p>
                  </li>
                  <li className={grade_level >= 3 ? styles.on : ''}>
                    <em />
                    <span>
                      <i className={`${styles.rankIcon} ${styles.rank4}`} />
                    </span>
                    <p>金牌</p>
                  </li>
                  <li className={grade_level >= 4 ? styles.on : ''}>
                    <em />
                    <span>
                      <i className={`${styles.rankIcon} ${styles.rank5}`} />
                    </span>
                    <p>钻石</p>
                  </li>
                </ul>
              </a>
            </div>
          </div>

          {/*<div className={styles.bottom}>*/}
          {/*<p className={styles.tip}>*/}
          {/*我的等级特权*/}
          {/*<a className={styles.link} href="#/localMerchant/myShop/regular">*/}
          {/*{privilegeTip}*/}
          {/*</a>*/}
          {/*</p>*/}
          {/*<ul>*/}
          {/*{list.map(({ id, main_title, sub_title, logo }) => (*/}
          {/*<li key={id}>*/}
          {/*<img src={logo} />*/}
          {/*<dl>*/}
          {/*<dt>{main_title}</dt>*/}
          {/*<dd>{sub_title}</dd>*/}
          {/*{id == 1 && (*/}
          {/*<a href="#/localMerchant/myShop/arrive">查看详情&gt;</a>*/}
          {/*)}*/}
          {/*{id == 2 && (*/}
          {/*<a href="#/localMerchant/myShop/order">查看详情&gt;</a>*/}
          {/*)}*/}
          {/*{id == 3 && (*/}
          {/*<a href="#/localMerchant/myShop/full">查看详情&gt;</a>*/}
          {/*)}*/}
          {/*</dl>*/}
          {/*</li>*/}
          {/*))}*/}
          {/*</ul>*/}
          {/*</div>*/}
        </div>
      </HeaderView>
    )
  }
}
